import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';

import { RequestType } from '../../../types/enums/request-enums';

const GetWarehouseList = (params: any) =>
    request({
        url: ApiURL.Query.GetWarehouseList,
        method: RequestType.GET,
        params,
    });

const GetGrowOpsLogs = (params: any) =>
    request({
        url: ApiURL.Query.GetGrowOpsLogs,
        method: RequestType.GET,
        params,
    });

const GrowManagementQuery = {
    GetWarehouseList,
    GetGrowOpsLogs,
};

export default GrowManagementQuery;
